<template>
  <div class="option-order-confirm">
    <div class="title">{{ safeOrder.coinname }}</div>
    <div class="circle-box" v-if="rate > 0 && safeOrder.status != 2">
      <van-circle
        v-model="currentRate"
        :rate="rate"
        :clockwise="false"
        :text="text"
        :stroke-width="100"
        :color="gradientColor"
        layer-color="#aaa"
      />
    </div>
    <div class="order-finished" v-else>
      <p v-if="safeOrder.status == 1" class="finished">
        {{ $t("option.finishing") }}
      </p>
      <p v-if="safeOrder.status == 2" class="finished">
        {{ $t("option.finished") }}
        <span :class="safeOrder.is_win == 1 ? 'data-up' : 'data-down'">{{
          safeOrder.status == 1 ? "--" : safeOrder.ploss
        }}</span>
      </p>
    </div>
    <div class="order-info">
      <p>
        {{ $t("option.order_price") }} :
        {{ safeOrder.status == 1 ? safeOrder.buyprice : safeOrder.sellprice }}
      </p>
      <p>{{ $t("option.order_cycle") }} : {{ safeOrder.time }}</p>
      <p>
        {{ $t("option.order_type") }} :
        <span :class="safeOrder.hyzd == 1 ? 'data-up' : 'data-down'">{{
          safeOrder.hyzd_text
        }}</span>
      </p>
      <p>{{ $t("option.order_money") }} : {{ safeOrder.num }}</p>
      <p v-if="safeOrder.status != 2">
        {{ $t("option.order_time") }} : {{ safeOrder.buytime }}
      </p>
      <p v-else>
        {{ $t("option.order_get") }} :
        <span :class="safeOrder.is_win == 1 ? 'data-up' : 'data-down'">{{
          safeOrder.status == 1 ? "--" : safeOrder.ploss
        }}</span>
      </p>
    </div>
    <div style="margin: 16px">
      <van-button class="web-btn" @click="closeInfo">
        {{ $t("option.order_btn") }}</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderConfirm",
  props: ["order_id"],
  computed: {
    safeOrderId() {
      return this.order_id || null;
    },
    text() {
      if (this.time < 0) return "0s";
      return this.time.toString() + " s";
    },
  },
  watch: {
    safeOrder(newval) {
      this.time = newval.time;
    },
  },
  data() {
    return {
      gradientColor: {
        "0%": "#d74e5a",
        "100%": "#d74e5a",
      },
      currentRate: 0,
      timer: null,
      rate: 100,
      ordertime: 0,
      time: 0,
      safeOrder: {},
    };
  },
  methods: {
    closeInfo() {
      if (this.timer) clearInterval(this.timer);
      this.$emit("close-order");
    },
    changeTime() {
      this.time = parseInt(this.time) - 1;
      this.rate = (parseInt(this.time) / parseInt(this.ordertime)) * 100;
      console.log(this.time)
          console.log(this.rate)
      if (this.rate <= 0) {
        if (this.timer) clearInterval(this.timer);

        this.getOrderInterval();
      }
    },
    getHyOrderInfo() {
      this._getHyOrderInfo();
    },
    async _getHyOrderInfo() {
      await this.$http({
        method: "post",
        url: "getHyOrderInfo",
        data: { order_id: this.safeOrderId },
      }).then((res) => {
        this.safeOrder = res.data;
        if (this.safeOrder.count_down > 0) {
          this.time =
            this.safeOrder.count_down <= 0 ? 0 : this.safeOrder.count_down;
          this.ordertime = this.safeOrder.time;
          this.rate = (parseInt(this.time) / parseInt(this.ordertime)) * 100;
          console.log(this.time)
          console.log(this.ordertime)
          console.log(this.rate)
          const that = this;
          this.$nextTick(() => {
            that.timer = setInterval(() => {
              that.changeTime();
            }, 1000);
          });
        } else {
          this.time = 0;
          this.rate = 100;
          if (this.safeOrder.status == 1) {
            if (!this.timer) this.getOrderInterval();
          } else {
            if (this.timer) clearInterval(this.timer);
          }
        }
      });
    },
    getOrderInterval() {
      const that = this;
      this.$nextTick(() => {
        that.timer = setInterval(() => {
          that._getHyOrderInfo();
        }, 5000);
      });
    },
  },
  mounted() {},
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style>
</style>
